import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Preventivo, PreventivoResponseDTO, VocePolizza } from '../shared/preventivo';

import { BackendApi } from '../shared/backend-api';

@Component({
  selector: 'app-step5',
  imports: [
    CommonModule, 
    FormsModule
  ],
  templateUrl: './step5.html',
  styleUrl: './step5.css'
})

export class Step5 {
  @Output() avanti = new EventEmitter<void>();

  selectedMethod: string | null = null;

  preventivo: PreventivoResponseDTO | null = null;

  massimale: number | null = null;
  voci: VocePolizza[] = [];

  // Campi aggiuntivi per metodo SDD
  codiceIban: string = '';
  codiceFiscaleIntestatario: string = '';
  nomeIntestatario: string = '';
  indirizzoIntestatario: string = '';
  codiceFiscaleContraente: string = '';
  nomeContraente: string = '';

  isLoading = false;
  errore: string | null = null;

  constructor(private preventivoService: Preventivo, private api: BackendApi) {
    this.preventivo = this.preventivoService.getPreventivo();
    this.massimale = this.preventivoService.getMassimale();
    this.voci = this.preventivoService.getVoci() || [];
  }

  selezionaMetodo(metodo: string) {
    this.selectedMethod = metodo;

    if (metodo === 'SDD') {
      const azienda = this.preventivoService.getDatiAzienda();
      if (azienda) {
        this.codiceFiscaleIntestatario = azienda.partitaIva;
        this.nomeIntestatario = azienda.ragioneSociale;
        this.nomeContraente = azienda.ragioneSociale;
        this.codiceFiscaleContraente = azienda.partitaIva;
        this.indirizzoIntestatario = azienda.indirizzoCompleto;
      }
    }
    else {
      this.codiceFiscaleIntestatario = '';
      this.nomeIntestatario = '';
      this.nomeContraente = '';
      this.codiceFiscaleContraente = '';
      this.indirizzoIntestatario = '';
    }
  }

  avantiStep() {
    if (!this.selectedMethod) {
      alert('Seleziona un metodo di pagamento');
      return;
    }

    const azienda = this.preventivoService.getDatiAzienda();
    const legale = this.preventivoService.getDatiLegale();
    const questionario = this.preventivoService.getQuestionario();
    const privacy = this.preventivoService.getPrivacyConsenso();
    const marketing = this.preventivoService.getMarketingConsenso();
    const productId = this.preventivo?.productId;

    if (!azienda || !legale || !privacy || !productId) {
      alert('Dati incompleti per completare il processo.');
      return;
    }

    this.isLoading = true;
    this.errore = null;

    // Costruzione oggetto metodoPagamento
    let metodoPagamento: any = { tipo: this.selectedMethod };

    if (this.selectedMethod === 'SDD') {
      if (!this.codiceIban || !this.codiceFiscaleIntestatario || !this.nomeIntestatario || !this.codiceFiscaleContraente || !this.nomeContraente) {
        alert('Completa tutti i campi richiesti per il pagamento SDD.');
        this.isLoading = false;
        return;
      }

      metodoPagamento = {
        tipo: 'SDD',
        codiceIban: this.codiceIban,
        codiceFiscaleIntestatario: this.codiceFiscaleIntestatario,
        nomeIntestatario: this.nomeIntestatario,
        indirizzoIntestatario: this.indirizzoIntestatario,
        codiceFiscaleContraente: this.codiceFiscaleContraente,
        nomeContraente: this.nomeContraente
      };
    }

    const body = {
      referralCode: this.preventivoService.getReferral() ?? null,
      productId,
      azienda: azienda,
      legale: legale,
      questionario: questionario,
      privacyConsenso: privacy,
      marketingConsenso: privacy,
      metodoPagamento: metodoPagamento
    };

    this.api.emettiPolizza(body).subscribe({
        next: (response) => {
          this.preventivoService.setMetodoPagamento(this.selectedMethod!);
          this.preventivoService.setEmissioneResponse(response);
          this.isLoading = false;
          this.avanti.emit();
        },
        error: (err) => {
          console.error('Errore API:', err);
          this.errore = 'Errore durante l\'emissione della polizza.';
          this.isLoading = false;
        }
      });
  }
}
